module.exports = __webpack_public_path__ + "close_feedBack.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_feedBack.png
// module id = 183
// module chunks = 0